import { GameLogic, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import {
  BaseCoreConstants,
  delayedCall,
  dispatcher,
  EventConstants,
  IEvent,
  ingenuity,
  IObject,
  killDelayedCall,
  Loading,
} from "@quest/base-core";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";

export class GameClientLogic extends GameLogic {
  /**
   * This method is overried to subsscribe Cascade reel Event
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION, this.onShowCascadeReelPresentation, this);
    dispatcher.on(eventDispatchers.RESET_CASCADE_COUNTER, this.resetCascadeSequenceCounter, this);
    dispatcher.on(eventDispatchers.STAGE_CLICK_ON_CASCADE, this.stageClickedOnCascade, this);

    dispatcher.on(eventDispatchers.ON_CASCADE_REELS, this.onCascadeReels, this);
  }

  /**
   * This method is overried to un-subsscribe Cascade reel Event
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.CHECK_AND_SHOW_NEXT_CASCADE_PRESENTATION, this.onShowCascadeReelPresentation, this);
    dispatcher.off(eventDispatchers.RESET_CASCADE_COUNTER, this.resetCascadeSequenceCounter, this);
    dispatcher.off(eventDispatchers.STAGE_CLICK_ON_CASCADE, this.stageClickedOnCascade, this);

    dispatcher.off(eventDispatchers.ON_CASCADE_REELS, this.onCascadeReels, this);
  }
  /**
   * we have created a cascade presentation for the game
   * this will work throught the multiple cascades and make the game flow sorted
   */
  private onShowCascadeReelPresentation(evt?: IEvent): void {
    const winSequenceCounter = this.model.getCascadeSequenceCounter(); // animation sequence counter , which increase its value agter every win sequence execution
    if (winSequenceCounter >= this.model.getCascadeSequence().length) {
      return;
    }
    const currentPresentation = this.model.getCascadeSequence()[winSequenceCounter]; // current win presentation to show from win sequence
    if (this.model.getCascadeSequenceCounter() < this.model.getCascadeSequence().length) {
      this.model.updateCascadeSequenceCounter();
    }
    switch (currentPresentation) {
      case "checkForReveal":
        this.onCheckForRevealSymbol();
        break;
      case "showCascadingWin":
        this.onShowCascadeWin();
        break;
      case "startNextLineToggle":
        this.startNextLineToggle();
        break;
      case "startNextCascade":
        this.startNextCascade();
        break;
      case "checkForWinAndSendClose":
        this.checkForWinAndSendClose();
        break;
    }
  }
  /**
   * overrided to add game specific presentations
   */
  protected onShowNextWinPresentation(evt?: IEvent): void {
    const winSequenceCounter = this.model.getAnimationSequenceCounter(); // animation sequence counter , which increase its value agter every win sequence execution
    if (winSequenceCounter >= this.model.getAnimationSequence().length) {
      return;
    }
    const sequenceArray = this.model.getAnimationSequence(); // animation sequence array
    const currentWinEventToShow = sequenceArray[winSequenceCounter]; // current win presentation to show from win sequence
    switch (currentWinEventToShow) {

      case "baitReveal":
        this.updateAnimationSequenceCounter();
        this.onShowBaitReveal();
        break;
      case "respinTriggeringAnimation":
        this.updateAnimationSequenceCounter();
        this.onRespinTriggeringAnimation();
        break;
      case "ShowFishRespin":
        this.updateAnimationSequenceCounter();
        this.onShowFishingRespinFeature();
        break;
      default:
        super.onShowNextWinPresentation(evt);
        break;
    }
  }
  /**
   * to play respin triggering animation
   */
  protected onRespinTriggeringAnimation(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getIsBaitPresent() &&
      (ingenuity.parserModel as GameParserModel).getBaitCount() >= gameConstants.BAIT_REVEAL_THRESHOLD
    ) {
      dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
      dispatcher.fireEvent(eventDispatchers.SHOW_BAIT_SYM_ANIM);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }
  /**
   * to show bait symbols on ytiggering
   */
  protected onShowBaitReveal(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getIsBaitPresent() &&
      (ingenuity.parserModel as GameParserModel).getBaitCount() >= gameConstants.BAIT_REVEAL_THRESHOLD
    ) {
      delayedCall("baitRevealDelay", 100, () => {
        killDelayedCall("baitRevealDelay");
        dispatcher.fireEvent(eventDispatchers.SHOW_REVEAL_SYMBOL, "chest");
      })
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  //Starts Reveal Symbol Presentation based on state.
  protected onCheckForRevealSymbol(): void {
    if ((ingenuity.parserModel as GameParserModel).getRevealAvailable() && ingenuity.configData.isRevealPresent) {
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        dispatcher.fireEvent(eventDispatchers.SHOW_REVEAL_SYMBOL);
      } else if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
        dispatcher.fireEvent(eventDispatchers.FG_SHOW_REVEAL_SYMBOL);
      }
    } else {
      this.onShowCascadeReelPresentation();
    }
  }
  /**
   * This method is use to show tickup during cascading
   */
  private onShowCascadeWin(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
      this.startWinPresentationBeforeCascade();
      this.startWinMeterTickUP();
      ingenuity.configData.stageClickOnCascade = true;
      dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
    } else {
      this.onShowCascadeReelPresentation();
    }
  }
  // Start cascade win frames and symbol animation
  private startWinPresentationBeforeCascade(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.SHOW_SYM_WIN);
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.SHOW_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.SHOW_QLINE_PLAYER_MSG);
    } else {
      dispatcher.fireEvent(eventDispatchers.SHOW_FG_SYM_WIN);
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_FG_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.SHOW_FG_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.FG_SHOW_QLINE_PLAYER_MSG);
    }
  }

  // Add to start next line toggle
  private startNextLineToggle(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount() !== 0) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA);
      this.model.setCascadeSequenceCounter(this.model.getCascadeSequenceCounter() - 1);
      this.handleWinFramesOnNextToggle();
    } else {
      this.onShowCascadeReelPresentation();
    }
  }
  /**
   * to remove previous clustor win frames and add new win frames on toggle
   */
  private handleWinFramesOnNextToggle(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.HIDE_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.SHOW_SYM_WIN);
      dispatcher.fireEvent(eventDispatchers.SHOW_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.HIDE_QLINE_PLAYER_MSG);
      dispatcher.fireEvent(eventDispatchers.SHOW_QLINE_PLAYER_MSG);
    } else {
      dispatcher.fireEvent(eventDispatchers.HIDE_FG_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.SHOW_FG_SYM_WIN);
      dispatcher.fireEvent(eventDispatchers.SHOW_FG_CLUSTER_WIN_FRAME);
      dispatcher.fireEvent(eventDispatchers.FG_HIDE_QLINE_PLAYER_MSG);
      dispatcher.fireEvent(eventDispatchers.FG_SHOW_QLINE_PLAYER_MSG);
    }
  }

  /**
   * This method is to show next cascade
   */
  private startNextCascade(): void {
    killDelayedCall(gameConstants.NEXT_LINE_TOGGLE);
    ingenuity.configData.stageClickOnCascade = false;
    dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
    (ingenuity.parserModel as GameParserModel).setCascadeLineToggleCount(0);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA);
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.HIDE_CLUSTER_WIN_FRAME);
      this.model.getIsWin() && dispatcher.fireEvent(eventDispatchers.HIDE_QLINE_PLAYER_MSG);
    } else {
      dispatcher.fireEvent(eventDispatchers.HIDE_FG_CLUSTER_WIN_FRAME);
      this.model.getIsWin() && dispatcher.fireEvent(eventDispatchers.FG_HIDE_QLINE_PLAYER_MSG);
    }
    if ((ingenuity.parserModel as GameParserModel).getCascadingCount() !== 0) {
      dispatcher.fireEvent(eventDispatchers.PARSE_NEXT_CASCADE_DATA);
    } else {
      this.onShowCascadeReelPresentation();
    }
  }
  /**
   * This method will check for cascade reels
   */
  private onCascadeReels(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadeWin()) {
      this.setWinlineAndWaysData();
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.BURST_SYMBOLS);
      dispatcher.fireEvent(eventDispatchers.UPDATE_PROGRESS_BAR_IN_BASEGAME);
    } else {
      dispatcher.fireEvent(eventDispatchers.FG_BURST_SYMBOLS);
      dispatcher.fireEvent(eventDispatchers.UPDATE_PROGRESS_BAR_IN_FREEGAME);
    }
  }
  /**
   * function will perform the end flow of cascade presentation
   */
  private checkForWinAndSendClose(): void {
    this.onCheckForWinAfterReelStop();
    if (!this.model.getIsWin() && !(ingenuity.parserModel as GameParserModel).getIsHoldAndRespinAvailable() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
    }
  }
  /**
   * reset cascade counter
   */
  private resetCascadeSequenceCounter(): void {
    this.model.setCascadeSequenceCounter(0);
  }
  /**
   * to udpate cascade counter on stage click
   */
  private stageClickedOnCascade(): void {
    this.model.setCascadeSequenceCounter(this.model.getCascadeSequence().indexOf("startNextCascade"));
    this.onShowCascadeReelPresentation();
  }
  /**
   * overrided to udpate respin check
   */
  protected onCheckForWinAfterReelStop(evt?: IEvent) {
    if ((this.model.getIsWin() && (ingenuity.parserModel as GameParserModel).getTotalWin()) ||
      (ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() || (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered() ||
      (ingenuity.parserModel as GameParserModel).getIsHoldAndRespinAvailable()
    ) {
      this.setWinlineAndWaysData();
      killDelayedCall(SlotConstantsBehavior.BROKEN_DELAY_FG);
      this.showNextWinPresentation();
    } else {
      delayedCall(SlotConstantsBehavior.NoWinDelay, SlotConstantsBehavior.setDelayForNoWin, () => {
        killDelayedCall(SlotConstantsBehavior.NoWinDelay);
        dispatcher.fireEvent(SlotEventConstants.SHOW_CONTAINERS, SlotConstantsBehavior.ButtonsContainerId);
      });
    }
    (ingenuity.parserModel as GameParserModel).setisSpinStarted(false);
  }
  /**
   * functoin will start respin feature
   */
  protected onShowFishingRespinFeature(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsHoldAndRespinAvailable()) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        ((ingenuity.parserModel as GameParserModel).getPromotionalFreeGame()) && dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, false);
        dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_AUTOPLAY_BEFORE_FEATURE);
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_RESPIN_FEATURE);
        dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_DURING_BIGWIN);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(
          EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED,
          (e) => {
            this.onShowFishingRespinFeature();
          },
          this,
          true
        );
      }
    } else {
      this.onShowNextWinPresentation();
    }
  }
  /**
   *  to reset cascade counter
   */
  protected onValidateBet(evt: IEvent) {
    this.model.setCascadeSequenceCounter(0);
    super.onValidateBet(evt);
  }
  /**
   *  to reset cascade counter
   */
  protected onValidateBetInFreeGame(evt: IEvent) {
    this.model.setCascadeSequenceCounter(0);
    super.onValidateBetInFreeGame(evt);
  }
  /**overrided to stop multiple onMarkerComplete Bindings. */
  protected onVisibilityChange(evt: IObject) {
    super.onVisibilityChange(evt);
    if (evt.target.visibilityState !== "visible") {
      if (ingenuity.deviceEnv.browser !== "EDGE" && ingenuity.deviceEnv.browser !== "IE10" && ingenuity.deviceEnv.browser !== "IE11") {
        if (!ingenuity.deviceEnv.isDesktop && (ingenuity.deviceEnv.getIsIpad() || ingenuity.deviceEnv.getDeviceOS() !== 'ios')) {
          dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_FULL_SCREEN_GAME);
        }
      }
    }
  }
  /**
   * to make this unction Bspot specific
   */
  protected handleGameAfterErrorResolved(): void {
    if(ingenuity.configData.isBSPOTEnable){
      super.handleGameAfterErrorResolved();
    }
  }
}
